import * as React from 'react';
import './_FieldsColumns.scss';
import { IFieldsColumnsProps } from './types';
import { Checkbox } from 'kui';
import { CLASS_LIST_VIEW } from '../../constants';
import { FIELDS_COLUMNS } from './constants';
import { SettingsSection } from '../../../base/components/SettingsSection/SettingsSection';
import { AnalyzeRender } from '../../../helpers/memoizeHelper';

// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`listView fieldsColumns`) : null;

export function FieldsColumns({
    cardFields,
    onClick,
}: IFieldsColumnsProps) {
    if (analyzeRender) analyzeRender.call('fieldsColumns', arguments[0]);

    const className = CLASS_LIST_VIEW + '-fields-columns';

    return (
        <SettingsSection
            className={className}
            title={FIELDS_COLUMNS}
        >
            {cardFields.map(field => (
                <Checkbox
                    key={field.value}
                    disabled={!field.isHideable}
                    direction={'left'}
                    className={className + '__item'}
                    checked={!field.isHideable || field.isShown}
                    onChange={() => onClick(field.value)}
                >
                    {field.title}
                </Checkbox>
            ))}
        </SettingsSection>
    )
}
